import { render, staticRenderFns } from "./AutocompleteToken.vue?vue&type=template&id=423661bd&scoped=true&"
import script from "./AutocompleteToken.vue?vue&type=script&lang=js&"
export * from "./AutocompleteToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423661bd",
  null
  
)

export default component.exports